// CUSTOM CODE for RUGETTE
// Shimmer-then-fade-in instead of images popping in one by one as each finishes downloading.
//
// Loaded as a global module (via snippets/scripts.liquid) rather than as an inline <script>
// inside card-gallery.liquid: sections like product-recommendations render their card-gallery
// markup asynchronously via morphSection() (assets/product-recommendations.js), which parses
// and inserts HTML without ever executing embedded <script> tags. If this file lived inline in
// card-gallery.liquid and no other card-gallery happened to be present in the page's initial
// HTML, these listeners would never register - leaving every "you may also like" image stuck
// shimmering forever. Loading it unconditionally in <head> guarantees the listeners exist
// before any morph/hydration inserts real card-gallery images.

const revealImage = (target) => {
  // Idempotency matters, not just as an optimization: the MutationObserver below watches
  // data-loaded to repair it when morph.js strips it (see below), so setAttribute()'ing
  // unconditionally would re-trigger that observer, which calls this again... forever.
  if (target.hasAttribute?.('data-loaded')) return;
  if (!target.matches?.('.card-gallery .product-media__image')) return;
  target.setAttribute('data-loaded', '');
};

// `complete` is trivially true for deferred slides with no `src` yet - currentSrc excludes those.
const revealIfComplete = (img) => {
  if (img.complete && img.currentSrc) revealImage(img);
};

for (const img of document.querySelectorAll('.card-gallery .product-media__image')) {
  revealIfComplete(img);
}

document.addEventListener('load', (event) => revealImage(event.target), { capture: true });
document.addEventListener('error', (event) => revealImage(event.target), { capture: true });

// Images already complete (eg. cached) when inserted never fire their own 'load'. Worse,
// filters/sorting go through assets/morph.js, which reconciles the grid in place: its
// copyAttributes() strips any attribute the fresh server HTML doesn't know about
// (morph.js:464-477) - including our client-only data-loaded, with no new 'load' event ever
// coming to restore it. A MutationObserver catches both cases (new nodes and morph's
// attribute patches), re-checking `complete` to repair data-loaded right after morph removes it.
new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    if (mutation.type === 'attributes') {
      revealIfComplete(mutation.target);
      continue;
    }
    for (const node of mutation.addedNodes) {
      if (node.nodeType !== 1) continue;
      if (node.matches?.('.product-media__image')) revealIfComplete(node);
      for (const img of node.querySelectorAll?.('.product-media__image') ?? []) {
        revealIfComplete(img);
      }
    }
  }
}).observe(document.body, {
  childList: true,
  subtree: true,
  attributes: true,
  attributeFilter: ['src', 'data-loaded'],
});
